<template>
    <v-card v-if="documentRule.id" class="document-card" :elevation="elevation" min-width="180px" min-height="360px">
        <v-card-title class="font-weight-medium subtitle-2">
            <TextLengthLimitations :text="documentRule.name" chars="25" ></TextLengthLimitations>
            <v-spacer></v-spacer>
            <v-tooltip top v-if="alert">
                <template #activator="data">
                    <v-icon class="icon-required" color="red" v-on="data.on">fa-exclamation-triangle</v-icon>
                </template>
                <span>{{ alert }}</span>
            </v-tooltip>
        </v-card-title>
        <v-card-text class="pt-0 pb-0">
            <v-row class="mb-2" no-gutters>
                <v-col>
                    <v-row justify="center">
                        <v-col>
                            <v-menu
                                    v-model="issue_date_flag"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            :error-messages="issueDateError"
                                            v-model="newDocumentFile.issue_date"
                                            label="Issue Date"
                                            prepend-icon="event"
                                            :disabled="lock"
                                            readonly
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker :max="moment.format(dateFormat)"
                                               v-model="newDocumentFile.issue_date"
                                               @input="autoCalculateExpiration(documentRule)">
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row no-gutters v-if="!isReport">
                        <v-col>
                            <v-menu
                                    v-model="expiration_date_flag"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    text
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            :error-messages="expirationDateError"
                                            v-model="newDocumentFile.expiration_date"
                                            label="Expiration Date"
                                            prepend-icon="event"
                                            readonly
                                            :disabled="documentRule.expiredInterval === DOCUMENT_RULE_CONFIGURATIONS.EXPIRATION.DEFAULT_VALUE || lock"
                                            v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker :min="moment.format(dateFormat)"
                                               v-model="newDocumentFile.expiration_date"
                                               @input="expiration_date_flag = false">
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>
                    <v-row no-gutters v-if="requiredLogHours">
                        <v-text-field
                                :error-messages="requiredLogHoursError"
                                v-model="newDocumentFile.requiredLogHours"
                                label="Log Hours"
                                type="number"
                        ></v-text-field>
                    </v-row>
                    <!--<v-row no-gutters v-if="requiresApproval">
                        <v-text-field
                                :error-messages="requiresApprovalError"
                                v-model="newDocumentFile.reviewer_cognito_username"
                                label="Reviewer Emails"
                        ></v-text-field>
                    </v-row>-->
                </v-col>
            </v-row>
        </v-card-text>
        <v-card-actions class="py-0">
            <v-row no-gutters>
                <v-col class="pt-0">
                    <fileUpload v-if="newDocumentFile.file_id && allowReplacement && !lock"
                                :file-name="createDocumentName(documentRule)"
                                @file-uploaded="fileUploaded($event, documentRule)"
                                :created_by= this.created_by
                                :belong= this.belong
                                :display_name= this.display_name
                                :document_type= this.document_type
                                :entity_type= this.entity_type
                                :document_rule="documentRule.id"
                    >
                    </fileUpload>
                    <fileUpload v-if="!newDocumentFile.file_id && !lock"
                                :created_by= this.created_by
                                :belong= this.belong
                                :display_name= this.display_name
                                :document_type= this.document_type
                                :entity_type= this.entity_type
                                :file-name="createDocumentName(documentRule)"
                                @file-uploaded="fileUploaded($event, documentRule)"
                                :document_rule="documentRule.id"
                    >
                    </fileUpload>
                    <file-download v-if="newDocumentFile.file_id"
                                   :name="newDocumentFile.name"
                                   :belongUserId="belong">
                    </file-download>
                </v-col>
            </v-row>
        </v-card-actions>
    </v-card>
</template>

<script>
    import {DOCUMENT_FILE_STATUS} from "@/shared/enums/DocumentFile";
    const FileUpload = ()=> import('@/fileHandler/components/FileUpload');
    const FileDownload = () => import('@/fileHandler/components/FileDownload');
    import {formUnsavedMixin} from "../../shared/mixins/FormUnsaved";
    import TextLengthLimitations from "@/components/common/TextLengthLimitations";
    import moment from 'moment';
    import {DOCUMENT_RULE_CONFIGURATIONS} from '../../shared/enums/DocumentRule';
    import {required, requiredIf} from 'vuelidate/lib/validators';
    import {DOCUMENT_FILE_TYPE} from "@/shared/enums/DocumentFile";

    export default {
        name: "documentFilesContainer",
        props: [
            'setDocumentRule', 'setDocumentRuleId', 'setDocumentFile', 'elevation', 'alert', 'canReplaceDoc', 'setFieldLock',
            'created_by', 'belong','display_name', 'document_type', 'entity_type','requiresApproval'
        ],
        mixins: [formUnsavedMixin],
        components:{
            FileUpload, FileDownload, TextLengthLimitations
        },
        data() {
            return {
                dateFormat: 'YYYY-MM-DD',
                expiration_date_flag: false,
                issue_date_flag: false,
                newDocumentFile:{
                    name: this.setDocumentFile.name || '',
                    documentRule: this.setDocumentFile.documentRule || '',
                    issue_date: this.setDocumentFile.issue_date || '',
                    file_id: this.setDocumentFile.file_id || '',
                    file: '',
                    expiration_date: this.setDocumentFile.expiration_date || '',
                    metadata: {},
                    status: '',
                    expiredInterval: this.setDocumentFile.expiredInterval || '',
                    reviewer_cognito_username: this.setDocumentFile.reviewer_cognito_username || ''
                },
                allowReplacement: this.canReplaceDoc || false,
                lock: this.setFieldLock || false,
                documentRule: {}
            };
        },
        validations: {
            newDocumentFile:{
                issue_date:{
                    required
                },
                expiration_date:{
                    required: requiredIf(function(item) {
                        return !this.isReport && (item.expiration_date == undefined ||
                            item.expiration_date == '' ||
                            item.expiration_date != DOCUMENT_RULE_CONFIGURATIONS.EXPIRATION.DEFAULT_VALUE) &&
                            this.documentRule.expiredInterval != DOCUMENT_RULE_CONFIGURATIONS.EXPIRATION.DEFAULT_VALUE;
                    })
                },
                requiredLogHours:{
                    required: requiredIf(function(item){
                        return this.isReport && this.requiredLogHours;
                    })
                },
                // reviewer_cognito_username:{
                //   required: requiredIf(function(item){
                //       return this.requiresApproval;
                //   })
                // }
            }
        },
        computed:{
            isReport(){
                return this.documentRule.type === DOCUMENT_FILE_TYPE.REPORT
            },
            requiredLogHours(){
                return this.documentRule.requiredLogHours;
            },
            moment(){
                return moment();
            },
            issueDateError(){
                const errors = [];
                if (!this.$v.newDocumentFile.issue_date.$dirty) {
                    return errors;
                }

                !this.$v.newDocumentFile.issue_date.required && errors.push("The issue date is required")
                return errors;
            },
            expirationDateError(){
                const errors = [];
                 if (!this.$v.newDocumentFile.expiration_date.$dirty) {
                     return errors;
                 }

                 !this.$v.newDocumentFile.expiration_date.required && errors.push("The expiration date is required")
                 return errors;
            },
            requiresApprovalError(){
                const errors = [];
                if (!this.$v.newDocumentFile.reviewer_cognito_username.$dirty) {
                    return errors;
                }

                !this.$v.newDocumentFile.reviewer_cognito_username.required && errors.push("The reviewer emails is required")
                return errors;
            },
            DOCUMENT_RULE_CONFIGURATIONS(){
                return DOCUMENT_RULE_CONFIGURATIONS;
            },
            requiredLogHoursError(){
                const errors = [];
                if (!this.$v.newDocumentFile.requiredLogHours.$dirty) {
                    return errors;
                }

                !this.$v.newDocumentFile.requiredLogHours.required && errors.push("The log hours is required")
                return errors;
            }
         },
        watch:{
            newDocumentFile:{
                handler(value){
                    this.$emit('document-changed', value);
                },
                deep: true
            },
            canReplaceDoc (value){
                this.allowReplacement = value;
            },
            setFieldLock(value){
                this.lock = value;
            },
        },
        methods:{
            createDocumentName(document){
                return document.name +'_'+ this.moment.unix();
            },
            fileUploaded($event, document) {
                this.newDocumentFile.name = $event.file.name;
                this.newDocumentFile.documentRule = document.name;
                this.newDocumentFile.file_id = $event.metadata.file_id;
                this.newDocumentFile.file = $event.file;
                this.newDocumentFile.metadata = {... $event.metadata};
                this.newDocumentFile.status = document.approvalRequired ? DOCUMENT_FILE_STATUS.PENDING_APPROVAL.status :
                    DOCUMENT_FILE_STATUS.UP_TO_DATE.status;
                this.newDocumentFile.expiredInterval = document.expiredInterval;

                if(this.requiresApproval)
                    this.newDocumentFile.metadata.reviewer_cognito_username = this.$store.getters.getUser.username; //this is temporal
            },
            autoCalculateExpiration(document) {
                this.issue_date_flag = false;

                if(document.expiredInterval !== DOCUMENT_RULE_CONFIGURATIONS.EXPIRATION.DEFAULT_VALUE && this.newDocumentFile.expiration_date === '') {
                    let expiration = document.expiredInterval.split('-');
                    this.newDocumentFile.expiration_date = moment(this.newDocumentFile.issue_date, this.dateFormat)
                        .add(expiration[0], expiration[1])
                        .format(this.dateFormat);
                }
            },
            validate(){
                this.$v.$touch();
                if(this.$v.$anyError){
                    return true;
                }
                //no errors
                return false;
            }
        },
        async mounted() {
            if(this.setDocumentRule != undefined && this.setDocumentRule != null && this.setDocumentRule.id){
                this.documentRule = this.setDocumentRule;
                return
            }

            if(this.setDocumentRuleId != ''){
                this.$log.debug('load lazy with id:', this.setDocumentRuleId)
                await this.$store.dispatch('getDocumentRule', {id: this.setDocumentRuleId});
                this.documentRule = this.$store.getters.getDocumentRule;
            }
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }

    .v-icon.icon-required{
        font-size:15px;
        margin-left: 5px;
    }

    .document-card{
        min-height: 292px;
    }
</style>